import { StepReventionsHowSales } from "../../data";


const ReventionsSale = () => {
    return(
        <div className="flex flex-col-reverse sm:grid sm:grid-cols-2 p-2 sm:px-12 sm:mx-24 my-12 mb-6">
            <div className="sm:col-span-1">
                <ul className="flex flex-col items-center gap-4">
                    {StepReventionsHowSales.length > 0 ? StepReventionsHowSales.map(item => (
                        <li
                            key={item.id}
                            className="bg-gray-600 text-gray-50 flex flex-row items-center gap-2 rounded-sm w-96 sm:w-80 h-20 p-4 px-6 hover:scale-105 duration-150">
                            <h4 className="text-xl font-bold w-16">{item.number}</h4>
                            <p className="sm:mr-1 text-lg sm:text-base">{item.desc}</p>
                        </li>
                    )):''}
                  
                </ul>
            </div>
            <div className="sm:col-span-1 text-gray-800 sm:mt-16">
                <h3 className=" font-semibold sm:mr-24 text-4xl sm:text-5xl mb-4">¿Cómo se aplica Renovación Total en venta?</h3>
                <div className="h-4 w-40 bg-gray-800 mb-2 sm:mb-10"></div>
                <p className="text-gray-700 text-lg sm:mr-48 my-4">
                En el caso de las <b>ventas</b>, una vez
                aprobado el presupuesto de los
                trabajos a realizar:
                </p>
            </div>
        </div>
    )
}

export default ReventionsSale;